import React, { Fragment } from "react"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"

import { RECHARGE_DOCUMENTS_BUTTON_SEARCH } from "shared/constants/idsElements"
import ModernFloatLabelSelect from "shared/components/ModernFloatLabelSelect"
import ModernButton from "shared/components/Button/ModernButton"
import Typograph from "components/Typograph"

import styles from "../../styles.css"

export const months = [
  { value: "", label: "Todos" },
  { value: "01", label: "Janeiro" },
  { value: "02", label: "Fevereiro" },
  { value: "03", label: "Março" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Maio" },
  { value: "06", label: "Junho" },
  { value: "07", label: "Julho" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Setembro" },
  { value: "10", label: "Outubro" },
  { value: "11", label: "Novembro" },
  { value: "12", label: "Dezembro" }
]

const currentYear = new Date().getFullYear()
export const years = [
  { value: "", label: "Todos" },
  ...Array.from({ length: 10 }, (_, i) => {
    const year = String(currentYear - i)
    return { value: year, label: year }
  })
]

const PhoneOptions = ({
  t,
  prePaidNumbers,
  selectedPhone,
  onChange,
  onSearch,
  selectedMonth,
  selectedYear,
  onChangeMonth,
  onChangeYear
}) => {
  return (
    <Fragment>
      <Typograph htmlTag="p" size="medium" color="outer_space" weight="regular">
        {t("MSG_0496")}
      </Typograph>

      <div className={styles.rowFields}>
        <ModernFloatLabelSelect
          className={styles.phoneSelect}
          name="prePaidNumber"
          options={prePaidNumbers}
          value={selectedPhone}
          onChange={onChange}
          label="Número de celular"
        />

        {selectedPhone && (
          <Fragment>
            <ModernFloatLabelSelect
              className={styles.monthSelect}
              name="month"
              options={months}
              value={selectedMonth}
              onChange={onChangeMonth}
              label="Mês"
            />
            <ModernFloatLabelSelect
              className={styles.yearSelect}
              name="year"
              options={years}
              value={selectedYear}
              onChange={onChangeYear}
              label="Ano"
            />
            <ModernButton
              id={RECHARGE_DOCUMENTS_BUTTON_SEARCH}
              shape="full"
              size="medium"
              buttonColor="deep_sea_green"
              text="Buscar"
              textColor="white"
              textSize="small"
              withBorderRadius
              onClick={onSearch}
            />
          </Fragment>
        )}
      </div>
    </Fragment>
  )
}

PhoneOptions.propTypes = {
  t: PropTypes.func,
  prePaidNumbers: PropTypes.array,
  selectedPhone: PropTypes.object,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  selectedMonth: PropTypes.object,
  selectedYear: PropTypes.object,
  onChangeMonth: PropTypes.func,
  onChangeYear: PropTypes.func
}

const enhance = compose(translate())

export default enhance(PhoneOptions)



// WEBPACK FOOTER //
// ./src/components/RechargeDocuments/components/PhoneOptions/index.js